import { useState, useEffect, useRef } from 'react'

import ScreenFrame from 'components/Frame/ScreenFrame'
import ContentFrame from 'components/Frame/ContentFrame'
import CoachDashboardCancellationSurveyTab from 'components/Feedback/CoachDashboardCancellationSurveyTab'
import AthleteAppStripeCancellationSurveyTab from 'components/Feedback/AthleteAppStripeCancellationSurveyTab'
import AthleteAppNetPromoterScoreTab from 'components/Feedback/AthleteAppNetPromoterScoreTab'
import AthleteAppFeedbackFormTab from 'components/Feedback/AthleteAppFeedbackFormTab'

export default function UserFeedbackView() {

    const tabs = [
        { name: 'Coach Dashboard Cancellation Surveys', key: 'coach-dashboard-cancellation-surveys' },
        { name: 'Athlete App Stripe Cancellation Surveys', key: 'athlete-app-stripe-cancellation-surveys' },
        { name: 'Athlete App Net Promoter Scores', key: 'athlete-app-net-promoter-scores' },
        { name: 'Athlete App Feedback Forms', key: 'athlete-app-feedback-forms' },
    ]

    const [selectedTab, setSelectedTab] = useState(tabs[0].key)
    const [highlightStyle, setHighlightStyle] = useState({ width: 0, left: 0 })
    const tabRefs = useRef({})
    const containerRef = useRef(null)

    const UpdateTabHighlight = () => {
        const selectedTabRef = tabRefs.current[selectedTab]
        if (selectedTabRef && containerRef.current) {
            const containerRect = containerRef.current.getBoundingClientRect()
            const tabRect = selectedTabRef.getBoundingClientRect()
            const leftOffset = tabRect.left - containerRect.left
            
            setHighlightStyle({
                width: tabRect.width,
                left: leftOffset
            })
        }
    }

    useEffect(() => {
        const rafId = requestAnimationFrame(() => {
            UpdateTabHighlight()
        })

        window.addEventListener('resize', UpdateTabHighlight)

        return () => {
            cancelAnimationFrame(rafId)
            window.removeEventListener('resize', UpdateTabHighlight)
        }
    }, [selectedTab, tabs])

    return (
        <ScreenFrame limitWidth={false}>
            <div className='flex items-center gap-x-4'>
                <h1 className="text-2xl font-semibold text-gray-900 tracking-tight pt-2 flex-grow">
                    Feedback
                </h1>
            
                <div className='w-fit'>
                    <ContentFrame>
                        <div 
                            ref={containerRef}
                            className='h-12 p-1 flex items-center gap-x-2 relative'
                        >
                            {highlightStyle.width > 0 && (
                                <div
                                    className="absolute border border-orange-500 bg-orange-50 rounded-xl transition-all duration-300 ease-out pointer-events-none"
                                    style={{
                                        width: `${highlightStyle.width}px`,
                                        left: `${highlightStyle.left}px`,
                                        top: '0.375rem',
                                        height: 'calc(100% - 0.75rem)'
                                    }}
                                />
                            )}
                            {tabs.map((tab) => (
                                <div 
                                    key={tab.key}
                                    ref={el => { if (el) tabRefs.current[tab.key] = el }}
                                    className={`
                                        py-1.5 px-4 rounded-xl cursor-pointer relative z-10 text-sm font-medium
                                        ${tab.key === selectedTab ? 'text-orange-600 font-medium' : 'text-gray-700'}
                                        hover:text-orange-600 transition-colors duration-200
                                    `}
                                    onClick={() => setSelectedTab(tab.key)}
                                >
                                    {tab.name}
                                </div>
                            ))}
                        </div>
                    </ContentFrame>
                </div>
            </div>

            {selectedTab === 'coach-dashboard-cancellation-surveys' && <CoachDashboardCancellationSurveyTab />}

            {selectedTab === 'athlete-app-stripe-cancellation-surveys' && <AthleteAppStripeCancellationSurveyTab />}

            {selectedTab === 'athlete-app-net-promoter-scores' && <AthleteAppNetPromoterScoreTab />}

            {selectedTab === 'athlete-app-feedback-forms' && <AthleteAppFeedbackFormTab />}
        </ScreenFrame>
    )
}
